export const ROBOT_PART_PLACE_SUCCESS = 'ROBOT_PART_PLACE_SUCCESS';

export const placeRobotPartSuccess = (id) => ({
  type: ROBOT_PART_PLACE_SUCCESS,
  payload: {
    id,
  }
});
